module.exports = __webpack_public_path__ + "img/keding.a31fbb8a.png";